import { trigger, transition, style, animate } from '@angular/animations';

export const easeInAnimation500 = trigger('easeIn', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in', style({ opacity: 1 }))
    ])
]);

export const easeInAnimation1000 = trigger('easeIn', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in', style({ opacity: 1 }))
    ])
]);

export const easeInAnimation2000 = trigger('easeIn', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in', style({ opacity: 1 }))
    ])
]);